import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import axios from 'axios';
import VueAxios from 'vue-axios';


const ficheros = {
    state: {},
    actions: {
        requestBarometro: ({ dispatch },) => {
            return new Promise((resolve, reject) => {
                axios.get(`/api/files/list/es`)
                    .then(response => {
                        let items = response.data.items.filter(e => e.type != 0);
                        resolve(items);
                    })
                    .catch(error => reject(error));
            });
        },
        requestOtros: ({ commit },) => {
            return new Promise((resolve, reject) => {

                axios.get(`/api/files/list/es?type=0`)
                    .then(response => {
                        resolve(response.data.items);
                    })
                    .catch(error => reject(error));

            });
        },
        requestDoc: ({ commit, dispatch }, data) => {
            axios.get(`/api/files/download/es/${data.id}`, { responseType: 'arraybuffer' })
                .then(response => {
                    let r = {
                        response: response,
                        data: data
                    };
                    dispatch('DownloadDoc', r);
                });
        },
        DownloadDoc: ({ }, data) => {
            var filename = '';
            var disposition = data.response.headers['content-disposition'];
            var type = data.response.headers['content-type'];
            if (disposition && disposition.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
            }


            var blob = new Blob([data.response.data], { type: type });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click()
        }
    }
}

export default ficheros;



// WEBPACK FOOTER //
// ./src/store/ficheros.js